/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AsyncJob } from '../models/AsyncJob';
import type { PolicyApplyRequest } from '../models/PolicyApplyRequest';
import type { PolicyCompareRequest } from '../models/PolicyCompareRequest';
import type { PolicyCompareStatistic } from '../models/PolicyCompareStatistic';
import type { PolicyDefaultException } from '../models/PolicyDefaultException';
import type { PolicyHistoryCategory } from '../models/PolicyHistoryCategory';
import type { PolicyHistoryResponse } from '../models/PolicyHistoryResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PolicyDefaultExceptionService {

    /**
     * List the company's policy default exceptions, ordered by position
     * @returns PolicyDefaultException Success
     * @throws ApiError
     */
    public static listPolicyDefaultExceptions(): CancelablePromise<Array<PolicyDefaultException>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/policyDefaultException',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Preview how many composites a draft default/exceptions configuration would change, before saving
     * @returns PolicyCompareStatistic Success
     * @throws ApiError
     */
    public static comparePolicyDefaults({
        requestBody,
    }: {
        requestBody: PolicyCompareRequest,
    }): CancelablePromise<PolicyCompareStatistic> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/policyDefaultException/compare',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Schedule a background job that saves a draft default/exceptions configuration and rebuilds composite policy assignments from it
     * @returns AsyncJob The apply job was scheduled; its status arrives through the async job notifications
     * @throws ApiError
     */
    public static applyPolicyDefaults({
        requestBody,
    }: {
        requestBody: PolicyApplyRequest,
    }): CancelablePromise<AsyncJob> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/policyDefaultException/apply',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * List one page of the company's Policy Defaults history in a year
     * Changes to the company default policies and exceptions, applies, and the manual job edits made on the Assign Policies page, newest first. Read from the audit log, so an event shows up a few seconds after the change. Hidden with a 404 while the policy_defaults flag is off.
     * @returns PolicyHistoryResponse Success
     * @throws ApiError
     */
    public static getPolicyDefaultsHistory({
        plan,
        year,
        limit,
        offset,
        category,
    }: {
        /**
         * Only job edits of composites in this plan, the plan the page shows. Company-wide events are listed whatever the plan.
         */
        plan?: number,
        /**
         * Calendar year to list, the current one when omitted; the current year runs up to now.
         */
        year?: number,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * Only the events of this tab; both when omitted.
         */
        category?: PolicyHistoryCategory,
    }): CancelablePromise<PolicyHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/policyDefaultException/history',
            query: {
                'plan': plan,
                'year': year,
                'limit': limit,
                'offset': offset,
                'category': category,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
